import fetch from "../../uilts/request.js";


export  default {
    saveMaiMaiQiShu(data) {
        return fetch.post('/order/saveqs', data)
    },
    lookMaiMaiQiShu(data) {
        return fetch.post('/order/getqishu', data);
    },
    updateMaiMaiQiShu(data) {
        return fetch.post('/order/updateqishu',data);
    },
    saveZuLinQiShu(data) {
        return fetch.post('/order/saveqs2', data)
    },
    lookZuLinQiShu(data) {
        return fetch.post('/order/getqishu', data);
    },
    updateZuLinQiShu(data) {
        return fetch.post('/order/updateqishu2',data);
    },
}
